<template>
	<div class="PlanesListado">
		<md-layout md-flex="100" md-align="center" class="m-t-24">
      <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="100" md-flex-large="60" md-flex-xlarge="40">
        <md-table-card class="w-100">
					<md-toolbar>
						<h1 class="md-title">Planes de pago registrados</h1>
					</md-toolbar>
					<md-table>
						<md-table-header>
							<md-table-row>
								<md-table-head>Plan</md-table-head>
								<md-table-head>Salario qnal</md-table-head>
								<md-table-head>Estatus</md-table-head>
								<md-table-head>Acciones </md-table-head>
							</md-table-row>
						</md-table-header>
						<md-table-body>
							<md-table-row v-for="plan in planes" :key="plan">
								<md-table-cell>{{plan.nombre_pln}}</md-table-cell>
								<md-table-cell>{{Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(plan.salario_qnal_pnh)}}</md-table-cell>
								<md-table-cell>{{plan.estatus_pln.toUpperCase()}}</md-table-cell>
								<md-table-cell>
									<md-button class="md-icon-button" @click.native="irEditarPlan(plan.plan)">
										<md-icon>edit</md-icon>
										<md-tooltip md-direction="left">Editar plan</md-tooltip>
									</md-button>
								</md-table-cell>
							</md-table-row>
						</md-table-body>
					</md-table>
				</md-table-card>
			</md-layout>
		</md-layout>
	</div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
import $ from "jquery";
import dt from "datatables.net";
export default {
  name: "PlanesListado",
  methods: {
    obtenerPlanes() {
      this.$http
        .post("planes", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "planes" in response.body) {
              this.planes = response.body.planes;
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    irEditarPlan(id) {
      this.$router.push({ name: "PlanesEditar", params: { id: id } });
    },
    irDetallePlan(id) {
      this.$router.push({ name: "PlanesDetalle", params: { id: id } });
    }
  },
  beforeCreate: function() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  beforeMount() {
    this.obtenerPlanes();
  },
  updated() {
    $(".md-table table").DataTable();
  },
  data() {
    return {
      planes: []
    };
  }
};
</script>


// WEBPACK FOOTER //
// PlanesListado.vue?ba45e7e6